import _URL from '../../URL/index';
const axios = _URL.axios;
export default {
    services: {
        getSettings: async (_id, token) => {
            return await axios(token).get(`/settings/suppliers/${_id}`);
        },
        updateSettingById: async (settingId, setting, token = "") => {
            return await axios(token).patch(`/settings/${settingId}`, setting);
        },
        setCredentias: async (platform, _id, token = '') => {
            return await axios(token).post(`/settings/auth/${_id}`, { platform: platform })
        },
        testSendEmail: async (operatorId, token = '') => {
            return await axios(token).get(`/settings/${operatorId}/testEmail`);
        },
        updateSettingLayoutsByUserId: (userId, payload, token) => {
            return axios(token).patch(`/operators/${userId}/settings`, payload);
        }
    }
}